import ProductDetailsList from '@/components/Product/ProductDetailsList'
import classes from "./WhyBuyFromUs.module.scss";

const WhyBuyFromUs = ({ items }) => {
  let whyBuyFromUsItems = []
  let title = items[0].title;

  {items[0].headers.map((header) => {
    whyBuyFromUsItems.push({ detailsItems: [header.details], detailsTitle:  header.header})
  })}

  return (
    <>
      <div className={`${classes['product__row']} container`}>
        <h2 className={classes["title"]}>{title}</h2>
        {whyBuyFromUsItems.map((headerData, headerIndex) => (
          <ProductDetailsList
            key={`accordion-${headerData._key}-${headerIndex}`}
            fields={{
              detailsTitle: headerData.detailsTitle,
              description: headerData.description,
              detailsItems: headerData.detailsItems
            }}
            enableToggle={true}
            expandOnLoad={false}
            showIcon={false}
            className="small-block"
          />
        ))}
      </div>
    </>
  );
};

export default WhyBuyFromUs;